

































































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import { IOrderDto, IOrderCountDto } from "@/types/interface/IOrderDto";
import { OrderDto } from "@/types/impl/OrderDto";
import { getOrders } from "@/api/net/order";
import { OrderStatus, PaymentStatus } from "@/types/enum/OrderEnum";
import OrderRow from "./components/order-row.vue";
import RefundOrderRow from "./components/refund-row.vue";
import OrderBase from "./mixins/order-row-base";
import { IOrderCancellationRequestDto } from "@/types/interface/IOrderCancellationRequestDto";
import { event, formatterDate } from "@/libs/utils";
import Badge from "@/components/Badge.vue";
import store from "../../store/index";
import { Route } from "vue-router";
import Scroller from "@/components/Scroll.vue";
import {
  IOrderPaging,
  IOrderStatusForRequestOrderList,
  IOrderPayload,
  IPreOrderCount
} from "../../types/interface/IOrderDto";
import { getOrderStatusForRequestOrderList } from "../../libs/utils";
import { getOrderById } from "../../api/net/order";
import { toLocalTime, Operatore } from "../../api/net/util";
type tabsType = { [key: string]: IOrderDto[] | IOrderCancellationRequestDto[] };
@Component({
  components: {
    OrderRow,
    RefundOrderRow,
    Badge,
    Scroller
  }
})
export default class Order extends OrderBase {
  tab: number = 0;
  tabs: tabsType = {
    Processing: [],
    PreOrder: [],
    Incoming: [],
    Preparing: [],
    Ready: [],
    Delivering: [],
    Completed: [],
    Rejected: []
  };

  text: string = "Lorem ipsum dolor sit amet";

  listHeight: number = 500;

  orderDto: IOrderDto = OrderDto;

  sendAudioEvent: boolean = true;

  activePaging: boolean = false;

  currentPage: number = 1;

  @Getter("orderTotal") total: number;

  public get preOrderDays(): Array<{
    date: string;
    weekday: string;
    count: number;
  }> {
    let preOderDaysArr: Array<{
      date: string;
      weekday: string;
      count: number;
    }> = [];
    let day = {
      date: "",
      weekday: 0,
      count: 0
    };
    enum DaysOfWeek {
      "SUN",
      "MON",
      "TUE",
      "WED",
      "THU",
      "FRI",
      "SAT"
    }
    for (let i: number = 0; i < 5; i++) {
      let time: Date = new Date(
        new Date().getTime() + 24 * 60 * 60 * 1000 * (i + 1)
      );
      let weekday: number = time.getDay();
      let date: string = toLocalTime(time, Operatore.Slant)
        .split(" ")[0]
        .substring(0, 5);
      let temp = JSON.parse(JSON.stringify(day));
      temp.date = date;
      temp.weekday = DaysOfWeek[weekday];
      let count: IPreOrderCount = this.preOrderCountForDate.find(
        (item: IPreOrderCount) => {
          return (
            toLocalTime(item.date, Operatore.Slant)
              .split(" ")[0]
              .substring(0, 5)
              .indexOf(temp.date) !== -1
          );
        }
      ) as IPreOrderCount;

      if (count) {
        Object.assign(temp, { count: count.orderCount });
      }
      preOderDaysArr.push(temp);
    }
    return preOderDaysArr;
  }

  public get totalPage(): number {
    return Math.ceil(this.total / 5);
  }

  public get moreThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.currentPage + 1;
      index < this.currentPage + 3 && index <= this.totalPage;
      index++
    ) {
      numberList.push(index);
    }
    return numberList;
  }

  public get lessThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.currentPage - 1;
      index > this.currentPage - 3 && index > 0;
      index--
    ) {
      numberList.push(index);
    }
    return numberList.sort((a, b) => a - b);
  }

  queryString: string = "";
  @Getter("isPc") isPc!: boolean;
  @Getter("keyword") keyword: string;
  @Getter("preOrderCountForDate") preOrderCountForDate!: IPreOrderCount[];
  @Getter("acceptPreOrder") acceptPreOrder!: boolean;

  @Mutation("handleKeyword")
  private handleKeyword: Function;

  limitSearch: boolean = false;

  async search() {
    if (!this.limitSearch) {
      this.limitSearch = true;
      setTimeout(() => {
        this.limitSearch = false;
      }, 1000);
      this.currentPage = 1;
      store.commit("handleCurrentOrderPage", 1);
      this.$store.commit("handleOrderList", []);
      store.commit("handleShowLoading", true);
      let orderStatus: OrderStatus[] = [];
      if (this.keyword) {
        orderStatus = [
          OrderStatus.WaitingForAcceptance,
          OrderStatus.Processing,
          OrderStatus.Ready,
          OrderStatus.Delivering,
          OrderStatus.Completed,
          OrderStatus.CancelRejected,
          OrderStatus.Cancelled,
          OrderStatus.Refunding,
          OrderStatus.Refunded,
          OrderStatus.CancelRequested,
          OrderStatus.Rejected
        ];
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus,
          keyword: this.keyword,
          isSearch: true,
          ExcludePreOrderStatuses: []
        });
      } else {
        orderStatus = getOrderStatusForRequestOrderList(this.currentTab);
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus,
          keyword: this.keyword,
          isSearch: true,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      }
      store.commit("handleShowLoading", false);
    }
  }

  @Watch("queryString")
  onKeywordChanged(val: string) {
    this.handleKeyword(val);
  }

  async toPage(page: number) {
    this.currentPage = page;
    store.commit("handleCurrentOrderPage", this.currentPage);
    store.commit("handleShowLoading", true);
    if (store.state.inPreOrderTab && store.state.preOrderDate) {
      await this.actionHandlePreOrderList({
        page: this.currentPage,
        orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
        date: store.state.preOrderDate
      });
      return;
    }
    if (this.currentTab === "Processing") {
      if (this.keyword) {
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          isSearch: true,
          ExcludePreOrderStatuses: []
        });
      } else {
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          isSearch: true,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      }
    } else {
      await this.actionHandleOrderList({
        page: this.currentPage,
        orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
        keyword: this.keyword,
        isSearch: true,
        ExcludePreOrderStatuses: []
      });
    }
  }

  @Watch("currentTab")
  onCurrentTabChanged(
    tabName: keyof IOrderStatusForRequestOrderList,
    oldTabName: keyof IOrderStatusForRequestOrderList
  ) {
    store.commit("handleOrderTotal", 0);
    store.commit("handleClearOrderList");
    store.commit("handleCurrentOrderTab", tabName);
    store.commit("handleCurrentOrderPage", 1);
    this.handleKeyword("");
    this.queryString = "";
    if (tabName === "PreOrder") {
      store.commit("handleIsInPreOrderTab", true);
      return;
    } else {
      store.commit("handleIsInPreOrderTab", false);
    }
    try {
      store.commit("handleShowLoading", true);
      if (tabName !== oldTabName && tabName === "Refunding") {
        this.actionHandleRefundOrderList(this.merchId);
        return;
      }
      if (tabName !== oldTabName) {
        this.currentPage = 1;
      }

      if (tabName === "Processing") {
        this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(tabName),
          keyword: this.keyword,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      } else {
        this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(tabName),
          keyword: this.keyword,
          ExcludePreOrderStatuses: []
        });
      }
    } catch (e) {
      store.commit("handleShowLoading", false);
    }
  }

  public get currentTab(): keyof IOrderStatusForRequestOrderList {
    return Object.keys(this.renderTabs)[
      this.tab
    ] as keyof IOrderStatusForRequestOrderList;
  }

  public getCurrentOrderCount(mappingText: string): number {
    interface orderCountItemType {
      mappingFiled: string;
      text: string;
      count: number;
    }
    let orderCountItem: orderCountItemType = this.orderStatusCount.find(
      x => x.text === mappingText
    ) as orderCountItemType;

    if (orderCountItem.text === "Refunding") {
      return this.refundOrderList.length;
    }

    if (orderCountItem.text === "PRE ORDER") {
      return this.preOrderDays.reduce(
        (
          total: number,
          currentItem: {
            date: string;
            weekday: string;
            count: number;
          }
        ) => {
          return currentItem.count + total;
        },
        0
      );
    }

    if (orderCountItem.text === "LIVE ORDERS") {
      return orderCountItem.count - this.getCurrentOrderCount("PRE ORDER");
    }

    if (orderCountItem) {
      return orderCountItem.count;
    }
    return 0;
  }

  public get renderTabs(): tabsType {
    let {
      Processing,
      PreOrder,
      Refunding,
      Incoming,
      Preparing,
      Ready,
      Delivering,
      Completed,
      Rejected
    } = this.tabs;
    let renderTabs: tabsType = {
      Processing,
      PreOrder,
      Refunding,
      Incoming,
      Preparing,
      Ready,
      Delivering,
      Completed,
      Rejected
    };
    if (!this.showCombinedTab) {
      delete renderTabs.Processing;
    }
    if (!this.acceptPreOrder) {
      delete renderTabs.PreOrder;
    }
    return renderTabs;
  }

  public get tabsRefund(): tabsType {
    let { Refunding } = this.tabs;
    return { Refunding };
  }

  public get tabsWithOutRefund(): Array<{
    text: string;
    item: IOrderDto[] | IOrderCancellationRequestDto[];
    tab: keyof IOrderStatusForRequestOrderList;
  }> {
    let {
      Processing,
      PreOrder,
      Incoming,
      Preparing,
      Ready,
      Delivering,
      Completed,
      Rejected
    } = this.tabs;
    let { Refunding } = this.tabsRefund;
    let tabsWithOutRefundArr: Array<{
      text: string;
      item: IOrderDto[] | IOrderCancellationRequestDto[];
      tab: keyof IOrderStatusForRequestOrderList;
    }> = [
      {
        text: "LIVE ORDERS",
        item: Processing as IOrderDto[],
        tab: "Processing"
      },
      { text: "PRE ORDER", item: PreOrder as IOrderDto[], tab: "PreOrder" },
      {
        text: "Refunding",
        item: this.refundOrderList,
        tab: "Refunding"
      },
      { text: "Incoming", item: Incoming as IOrderDto[], tab: "Incoming" },
      { text: "Preparing", item: Preparing as IOrderDto[], tab: "Preparing" },
      { text: "Ready", item: Ready as IOrderDto[], tab: "Ready" },
      {
        text: "Delivering",
        item: Delivering as IOrderDto[],
        tab: "Delivering"
      },
      { text: "Completed", item: Completed as IOrderDto[], tab: "Completed" },
      { text: "Rejected", item: Rejected as IOrderDto[], tab: "Rejected" }
    ];
    if (!this.showCombinedTab) {
      const combinedTabIndex: number = tabsWithOutRefundArr.findIndex(
        (item: {
          text: string;
          item: IOrderDto[] | IOrderCancellationRequestDto[];
          tab: keyof IOrderStatusForRequestOrderList;
        }) => {
          return item.text === "LIVE ORDERS";
        }
      );
      tabsWithOutRefundArr.splice(combinedTabIndex, 1);
    }
    if (!this.acceptPreOrder) {
      const preOrderTabIndex: number = tabsWithOutRefundArr.findIndex(
        (item: {
          text: string;
          item: IOrderDto[] | IOrderCancellationRequestDto[];
          tab: keyof IOrderStatusForRequestOrderList;
        }) => {
          return item.text === "PRE ORDER";
        }
      );
      tabsWithOutRefundArr.splice(preOrderTabIndex, 1);
    }
    return tabsWithOutRefundArr;
  }

  public get orderContentHeight(): number {
    return document.body.offsetHeight - 160;
  }
  @Getter("orderStatusCount") orderStatusCount: IOrderCountDto;
  @Getter("showCombinedTab") showCombinedTab!: boolean;
  @Getter("merchId") merchId!: string;
  @Getter("orderList") orderList!: IOrderDto[];
  @Getter("refundOrderList") refundOrderList!: IOrderCancellationRequestDto[];

  @Watch("refundOrderList", { immediate: true, deep: true })
  onChangeRefundOrderList(
    newRefundOrderList: IOrderCancellationRequestDto[],
    oldRefundOrderList: IOrderCancellationRequestDto[]
  ) {
    this.tabs["Refunding"] = [...this.refundOrderList];
    if (
      newRefundOrderList &&
      oldRefundOrderList &&
      newRefundOrderList.length &&
      newRefundOrderList.length > oldRefundOrderList.length
    ) {
      if (store.state.isPc || store.state.openInBrowser) {
        this.$playAudio.play();
      }
      if (this.sendAudioEvent) {
        event("onNewOrderReceived", "");
        this.sendAudioEvent = false;
        setTimeout(() => {
          this.sendAudioEvent = true;
        }, 5000);
      }
      this.handleShowNewOrderModal(true);
    }

    this.clearOrderLoopPalySoundTimer(
      this.orderStatusCount,
      this.orderStatusCount
    );
  }

  @Watch("orderStatusCount", { immediate: true, deep: true })
  setOrderLoopPalySoundTimer(newVal: IOrderCountDto, oldVal: IOrderCountDto) {
    this.clearOrderLoopPalySoundTimer(newVal, oldVal);
  }

  clearOrderLoopPalySoundTimer(
    newOrderStatusCount: IOrderCountDto,
    oldOrderStatusCount: IOrderCountDto
  ) {
    let oldOrderCount = 0;
    let newOrderCount = 0;
    if (newOrderStatusCount) {
      newOrderCount = (newOrderStatusCount.find(x => {
        return x.text === "Incoming";
      }) as {
        mappingFiled: string;
        text: string;
        count: number;
      }).count;
    }
    if (oldOrderStatusCount) {
      let oldOrderCount = (oldOrderStatusCount.find(x => {
        return x.text === "Incoming";
      }) as {
        mappingFiled: string;
        text: string;
        count: number;
      }).count;
    }
    if (this.refundOrderList.length || newOrderCount) {
      if (window.orderLoopPalySoundTimer) {
        clearInterval(window.orderLoopPalySoundTimer);
        window.orderLoopPalySoundTimer = null;
      }
      window.orderLoopPalySoundTimer = setInterval(() => {
        if (store.state.isPc || store.state.openInBrowser) {
          this.$playAudio.play();
        }
        if (this.sendAudioEvent) {
          event("onNewOrderReceived", "");
          this.sendAudioEvent = false;
          setTimeout(() => {
            this.sendAudioEvent = true;
          }, 5000);
        }
        this.handleShowNewOrderModal(true);
      }, 60000);
      return;
    } else {
      clearInterval(window.orderLoopPalySoundTimer);
      window.orderLoopPalySoundTimer = null;
      return;
    }
  }

  propOrderStatusForRequestOrderList() {
    return getOrderStatusForRequestOrderList(this.currentTab);
  }

  @Watch("$route")
  onRouteChange() {
    this.$nextTick(() => {
      if (this.currentTab === "Processing") {
        this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      } else {
        this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          ExcludePreOrderStatuses: []
        });
      }
      this.actionHandleRefundOrderList(this.merchId);
    });
  }

  inComingAndRefundCount: boolean = false;

  @Watch("orderList", { immediate: true, deep: true })
  onOrderListChange(
    newOrderList: IOrderDto[] | IOrderCancellationRequestDto[],
    oldOrderList: IOrderDto[] | IOrderCancellationRequestDto[]
  ) {
    this.tabs["Processing"] = newOrderList;

    this.tabs["Incoming"] = newOrderList;

    this.tabs["Preparing"] = newOrderList;

    this.tabs["Ready"] = newOrderList;

    this.tabs["Delivering"] = newOrderList;

    if (this.currentTab === "Completed" && !this.keyword) {
      let newCompletedOrderList: IOrderDto[] = (newOrderList as IOrderDto[]).filter(
        (x: IOrderDto) => x.hasPendingApprovalRefund === false
      );
      this.tabs["Completed"] = newCompletedOrderList;
    } else {
      this.tabs["Completed"] = newOrderList;
    }

    this.tabs["Rejected"] = newOrderList;

    this.incomingLength = this.tabs["Incoming"].length;
  }

  incomingLength: number = 0;
  @Watch("orderStatusCount", { immediate: true, deep: true })
  showModal(newVal: IOrderCountDto, oldVal: IOrderCountDto) {
    let newOrderCount = 0;
    let oldOrderCount = 0;
    if (newVal) {
      newOrderCount = (newVal.find(x => {
        return x.text === "Incoming";
      }) as {
        mappingFiled: string;
        text: string;
        count: number;
      }).count;
    }

    if (oldVal) {
      oldOrderCount = (oldVal.find(x => {
        return x.text === "Incoming";
      }) as {
        mappingFiled: string;
        text: string;
        count: number;
      }).count;
    }

    if (newOrderCount > oldOrderCount) {
      if (store.state.isPc || store.state.openInBrowser) {
        this.$playAudio.play();
      }
      if (this.sendAudioEvent) {
        event("onNewOrderReceived", "");
        this.sendAudioEvent = false;
        setTimeout(() => {
          this.sendAudioEvent = true;
        }, 5000);
      }
      this.handleShowNewOrderModal(true);
    }
  }

  @Mutation("handleShowNewOrderModal")
  private handleShowNewOrderModal!: Function;

  @Mutation("handleOrderList") handleOrderList!: (
    orderList: IOrderDto[]
  ) => void;

  @Action("handleOrderList")
  private actionHandleOrderList!: (payload: IOrderPayload) => Promise<void>;

  @Action("handleRefundOrderList")
  private actionHandleRefundOrderList!: (merchId?: string) => Promise<void>;

  resize() {
    this.listHeight = document.body.offsetHeight - 260;
    window.onresize = () => {
      this.listHeight = document.body.offsetHeight - 260;
    };
  }

  async updateOrderList(orderId: string, merchId: string) {
    // await getOrderById(orderId);
    if (this.currentTab === "Processing") {
      if (this.keyword) {
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          ExcludePreOrderStatuses: []
        });
      } else {
        await this.actionHandleOrderList({
          page: this.currentPage,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          keyword: this.keyword,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering
          ]
        });
      }
    } else {
      await this.actionHandleOrderList({
        page: this.currentPage,
        orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
        keyword: this.keyword,
        ExcludePreOrderStatuses: []
      });
    }
    // await this.actionHandleRefundOrderList();
  }

  async updatePreOrderList() {
    await this.actionHandlePreOrderList({
      page: store.state.currentOrderPage,
      orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
      date: store.state.preOrderDate
    });
    store.commit("handleShowLoading", false);
  }

  @Action("handlePreOrderList")
  private actionHandlePreOrderList!: (payload: {
    page: number;
    orderStatus: OrderStatus[];
    date: string;
  }) => Promise<void>;

  async getPreOrders(
    day: { date: string; weekday: string },
    panelIndex: number
  ) {
    const openPanel: boolean = !(this.$refs.panel as Element[])[panelIndex]
      .isActive;
    if (openPanel) {
      store.commit("handleShowLoading", true);
      try {
        store.commit("handleClearOrderList");
        this.currentPage = 1;
        store.commit("handleCurrentOrderPage", 1);
        const year = new Date(
          toLocalTime(
            this.preOrderCountForDate[panelIndex].date,
            Operatore.Slant
          )
        ).getFullYear();
        const fullDate: string = formatterDate(new Date(`${year}-${day.date}`));
        store.commit("handlePreOrderDate", fullDate);
        const params = {
          page: 1,
          orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
          date: fullDate
        };
        await this.actionHandlePreOrderList(params);
      } catch (e) {
      } finally {
        store.commit("handleShowLoading", false);
      }
    } else {
      store.commit("handlePreOrderDate", "");
      store.commit("handleClearOrderList");
      store.commit("handleOrderTotal", 0);
    }
  }
  async updateRefundOrderList() {
    await this.actionHandleRefundOrderList();
  }

  public get forbidSearching(): boolean {
    if (this.currentTab === "Refunding" || this.currentTab === "PreOrder") {
      return true;
    } else {
      return false;
    }
  }

  // public get localPreOrderDate(): string[] {
  //   let arr: string[] = this.preOrderCountForDate.map(item => {
  //     return toLocalTime(new Date(item.date), Operatore.Slant);
  //   });
  //   console.log(arr, 111);
  //   return arr;
  // }

  handleSearchKeydown(e: any) {
    if (e.keyCode === 13) {
      this.search();
    }
  }

  pageVisibilitychange() {
    if (
      sessionStorage.getItem("openInBrowser") &&
      sessionStorage.getItem("token") &&
      !document.hidden
    ) {
      const page: string = this.$route.name as string;
      switch (page) {
        case "Orders":
          if (store.state.inPreOrderTab) {
            if (store.state.preOrderDate) {
              this.actionHandlePreOrderList({
                page: store.state.currentOrderPage,
                orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
                date: store.state.preOrderDate
              });
            }
          } else {
            if (this.currentTab === "Processing") {
              if (this.keyword) {
                this.actionHandleOrderList({
                  page: this.currentPage,
                  orderStatus: getOrderStatusForRequestOrderList(
                    this.currentTab
                  ),
                  keyword: this.keyword,
                  ExcludePreOrderStatuses: []
                });
              } else {
                this.actionHandleOrderList({
                  page: this.currentPage,
                  orderStatus: getOrderStatusForRequestOrderList(
                    this.currentTab
                  ),
                  keyword: this.keyword,
                  ExcludePreOrderStatuses: [
                    OrderStatus.Processing,
                    OrderStatus.Ready,
                    OrderStatus.Delivering
                  ]
                });
              }
            } else {
              this.actionHandleOrderList({
                page: this.currentPage,
                orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
                keyword: this.keyword,
                ExcludePreOrderStatuses: []
              });
            }
          }
          break;
      }
    }
  }

  mounted() {
    this.resize();
    this.queryString = store.state.keyword;
    this.currentPage = store.state.currentOrderPage;
    this.$nextTick(() => {
      if (this.merchId && this.isPc) {
        if (this.currentTab === "Processing") {
          if (this.keyword) {
            this.actionHandleOrderList({
              page: this.currentPage,
              orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
              keyword: this.queryString,
              ExcludePreOrderStatuses: []
            });
          } else {
            this.actionHandleOrderList({
              page: this.currentPage,
              orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
              keyword: this.queryString,
              ExcludePreOrderStatuses: [
                OrderStatus.Processing,
                OrderStatus.Ready,
                OrderStatus.Delivering
              ]
            });
          }
        } else {
          this.actionHandleOrderList({
            page: this.currentPage,
            orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
            keyword: this.queryString,
            ExcludePreOrderStatuses: []
          });
        }
        this.actionHandleRefundOrderList(this.merchId);
      }
    });
    document.addEventListener(
      "visibilitychange",
      this.pageVisibilitychange,
      true
    );
  }
  timer: any;
  updated() {
    // let timer;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (
        this.tabsWithOutRefund[this.tab].item.length &&
        this.tabsWithOutRefund[this.tab].item.length === 0
      ) {
        store.commit("handleShowLoading", false);
      }
    }, 3000);
  }

  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.pageVisibilitychange,
      true
    );
  }
}
